import { Chip } from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import { eventTypes } from "../selectors/EventTypeSelector";

const eventTypeIcons: Record<string, React.ReactElement> = {
	D: <BuildIcon />,
	M: <BuildIcon />,
	H: <EventBusyIcon />,
};

type Props = {
	eventTypeCode: string;
	start: Date;
	remainingMinutes: number | null;
};

export const ActiveEventChip = ({
	eventTypeCode,
	start,
	remainingMinutes,
}: Props) => {
	if (!eventTypeCode) return null;

	const eventType = eventTypes.find((et) => et.code === eventTypeCode);
	if (!eventType) return null;

	const formatTime = (totalMinutes: number): string => {
		const abs = Math.abs(totalMinutes);
		const days = Math.floor(abs / (24 * 60));
		const hours = Math.floor((abs % (24 * 60)) / 60);
		const mins = abs % 60;
		const parts: string[] = [];
		if (days > 0) parts.push(`${days}d`);
		if (hours > 0 || days > 0) parts.push(`${hours}h`);
		parts.push(`${mins}m`);
		return parts.join(" ");
	};

	let label: string;

	if (remainingMinutes != null) {
		label = `${eventType.name.toUpperCase()} ${formatTime(remainingMinutes)} REMAINING`;
	} else {
		const elapsedMs = Date.now() - new Date(start).getTime();
		const elapsedMinutes = Math.max(0, Math.floor(elapsedMs / 60000));
		label = `${eventType.name.toUpperCase()} ${formatTime(elapsedMinutes)} ELAPSED`;
	}

	return (
		<Chip
			data-test-id="active-event-chip"
			icon={eventTypeIcons[eventTypeCode]}
			label={label}
			size="small"
			variant="outlined"
			sx={{
				fontWeight: 700,
				fontSize: "0.7rem",
				borderRadius: 1,
				borderColor: eventType.borderColor,
				backgroundColor: eventType.backgroundColor,
				color: eventType.textColor,
				"& .MuiChip-label": {
					color: eventType.textColor,
				},
				"& .MuiChip-icon": {
					color: eventType.textColor,
				},
			}}
		/>
	);
};
